export enum BuildBatchAction {
  REMOVE_FROM_QUEUE,
  STOP,
  REMOVE,
  ADD_TO_FAVORITES,
  COMMENT,
  PIN,
  UNPIN,
  ADD_TAGS,
}

export const BuildBatchActionsOrder = [
  BuildBatchAction.REMOVE_FROM_QUEUE,
  BuildBatchAction.STOP,
  BuildBatchAction.REMOVE,
  BuildBatchAction.PIN,
  BuildBatchAction.UNPIN,
  BuildBatchAction.ADD_TAGS,
  BuildBatchAction.COMMENT,
  BuildBatchAction.ADD_TO_FAVORITES,
]
